import {
  AirplaneTakeoffIcon,
  ArchiveIcon,
  ArrowCircleUpIcon,
  ArrowDownRightIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowsLeftRightIcon,
  BankIcon,
  BedIcon,
  BriefcaseIcon,
  BuildingOfficeIcon,
  CameraIcon,
  CarIcon,
  CaretDownIcon,
  CaretRightIcon,
  CaretUpIcon,
  ChatCenteredDotsIcon,
  ChatCircleDotsIcon,
  ChatCircleIcon,
  ChatCircleTextIcon,
  ChatsCircleIcon,
  ListChecksIcon,
  CheckCircleIcon,
  CheckIcon,
  CheckSquareIcon,
  SquareIcon,
  CircleHalfIcon,
  ClockCountdownIcon,
  ClockIcon,
  CompassIcon,
  CopyIcon,
  CreditCardIcon,
  CrownSimpleIcon,
  CurrencyCircleDollarIcon,
  DeviceMobileIcon,
  DotsSixVerticalIcon,
  DotsThreeIcon,
  DotsThreeVerticalIcon,
  EnvelopeIcon,
  FlagIcon,
  GearSixIcon,
  GlobeHemisphereWestIcon,
  HashIcon,
  HeadsetIcon,
  HouseIcon,
  IdentificationBadgeIcon,
  InvoiceIcon,
  KeyboardIcon,
  LifebuoyIcon,
  LightningIcon,
  LightningSlashIcon,
  LinkSimpleIcon,
  LockSimpleIcon,
  MagnifyingGlassIcon,
  MicrosoftTeamsLogoIcon,
  MinusCircleIcon,
  MoonIcon,
  PackageIcon,
  PaletteIcon,
  PauseCircleIcon,
  PencilSimpleIcon,
  PlayCircleIcon,
  PlusIcon,
  ProhibitIcon,
  PushPinIcon,
  PushPinSimpleIcon,
  QuestionIcon,
  ReceiptIcon,
  RocketLaunchIcon,
  RowsPlusBottomIcon,
  RowsPlusTopIcon,
  ShieldCheckIcon,
  ShieldWarningIcon,
  SidebarIcon,
  SidebarSimpleIcon,
  SignOutIcon,
  SlackLogoIcon,
  SlidersIcon,
  SmileyIcon,
  SmileyMehIcon,
  SmileyXEyesIcon,
  SortAscendingIcon,
  SparkleIcon,
  SquaresFourIcon,
  StarIcon,
  SunIcon,
  TargetIcon,
  TicketIcon,
  TrashIcon,
  TrayIcon,
  UserCircleCheckIcon,
  UserCircleIcon,
  UserIcon,
  UserPlusIcon,
  UsersFourIcon,
  UsersThreeIcon,
  WarningIcon,
  WarningOctagonIcon,
  WhatsappLogoIcon,
  XCircleIcon,
  XIcon,
  type Icon,
  type IconProps,
} from '@phosphor-icons/react';

const ICONS = {
  airplane: AirplaneTakeoffIcon,
  archive: ArchiveIcon,
  'arrow-down-right': ArrowDownRightIcon,
  'arrow-left': ArrowLeftIcon,
  'arrow-right': ArrowRightIcon,
  'arrow-up-circle': ArrowCircleUpIcon,
  'arrows-left-right': ArrowsLeftRightIcon,
  bank: BankIcon,
  bed: BedIcon,
  briefcase: BriefcaseIcon,
  'building-office': BuildingOfficeIcon,
  camera: CameraIcon,
  car: CarIcon,
  'caret-down': CaretDownIcon,
  'caret-right': CaretRightIcon,
  'caret-up': CaretUpIcon,
  'chat-circle': ChatCircleIcon,
  'chat-circle-dots': ChatCircleDotsIcon,
  'chat-circle-text': ChatCircleTextIcon,
  'list-checks': ListChecksIcon,
  'chat-dots': ChatCenteredDotsIcon,
  chats: ChatsCircleIcon,
  check: CheckIcon,
  'check-square': CheckSquareIcon,
  square: SquareIcon,
  'check-circle': CheckCircleIcon,
  'circle-half': CircleHalfIcon,
  clock: ClockIcon,
  'clock-countdown': ClockCountdownIcon,
  close: XIcon,
  compass: CompassIcon,
  copy: CopyIcon,
  'credit-card': CreditCardIcon,
  crown: CrownSimpleIcon,
  currency: CurrencyCircleDollarIcon,
  'device-mobile': DeviceMobileIcon,
  'dots-six-vertical': DotsSixVerticalIcon,
  'dots-three': DotsThreeIcon,
  'dots-vertical': DotsThreeVerticalIcon,
  edit: PencilSimpleIcon,
  envelope: EnvelopeIcon,
  flag: FlagIcon,
  globe: GlobeHemisphereWestIcon,
  hash: HashIcon,
  headset: HeadsetIcon,
  house: HouseIcon,
  identity: IdentificationBadgeIcon,
  invoice: InvoiceIcon,
  keyboard: KeyboardIcon,
  lifebuoy: LifebuoyIcon,
  lightning: LightningIcon,
  'lightning-slash': LightningSlashIcon,
  'link-simple': LinkSimpleIcon,
  lock: LockSimpleIcon,
  'magnifying-glass': MagnifyingGlassIcon,
  'minus-circle': MinusCircleIcon,
  moon: MoonIcon,
  package: PackageIcon,
  palette: PaletteIcon,
  'pause-circle': PauseCircleIcon,
  pin: PushPinIcon,
  'pin-outline': PushPinSimpleIcon,
  'play-circle': PlayCircleIcon,
  plus: PlusIcon,
  prohibit: ProhibitIcon,
  question: QuestionIcon,
  receipt: ReceiptIcon,
  rocket: RocketLaunchIcon,
  'rows-plus-bottom': RowsPlusBottomIcon,
  'rows-plus-top': RowsPlusTopIcon,
  settings: GearSixIcon,
  'shield-check': ShieldCheckIcon,
  'shield-warning': ShieldWarningIcon,
  sidebar: SidebarIcon,
  'sidebar-simple': SidebarSimpleIcon,
  'sign-out': SignOutIcon,
  slack: SlackLogoIcon,
  sliders: SlidersIcon,
  smiley: SmileyIcon,
  'smiley-meh': SmileyMehIcon,
  'smiley-x-eyes': SmileyXEyesIcon,
  'sort-ascending': SortAscendingIcon,
  sparkle: SparkleIcon,
  squares: SquaresFourIcon,
  star: StarIcon,
  sun: SunIcon,
  target: TargetIcon,
  teams: MicrosoftTeamsLogoIcon,
  ticket: TicketIcon,
  trash: TrashIcon,
  tray: TrayIcon,
  user: UserCircleIcon,
  'user-check': UserCircleCheckIcon,
  'user-line': UserIcon,
  'user-plus': UserPlusIcon,
  users: UsersThreeIcon,
  'users-four': UsersFourIcon,
  warning: WarningIcon,
  'warning-octagon': WarningOctagonIcon,
  whatsapp: WhatsappLogoIcon,
  'x-circle': XCircleIcon,
} as const satisfies Record<string, Icon>;

export type AppIconName = keyof typeof ICONS;

export function isAppIconName(name: string): name is AppIconName {
  return Object.hasOwn(ICONS, name);
}

type Props = {
  name: AppIconName;
  size?: string | number;
  weight?: IconProps['weight'];
  className?: string;
};

export function AppIcons({
  name,
  size,
  weight = 'regular',
  className,
}: Readonly<Props>): React.JSX.Element | null {
  const Cmp: Icon | undefined = isAppIconName(name) ? ICONS[name] : undefined;
  if (!Cmp) return null;
  return <Cmp size={size} weight={weight} className={className} aria-hidden />;
}
